import React, { useEffect, useState } from 'react';
import { array, func, object } from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { get } from 'lodash';

import queryString from 'query-string';

import MaterialTable from 'material-table';

import EsmsPage from '../../components/EsmsPage';

import useSelectedAgent from '../../hooks/useSelectedAgent';

import * as IotHubActions from '../../actions/iotHubActions';

import classes from './AgentLogsPage.module.css';

const AgentLogsPage = ({
    companyInfo,
    fetchLogs,
    history,
    location,
    logs,
    setLogData
}) => {

    const search = new URLSearchParams(location.search);
    const queryValues = queryString.parse(history.location.search);

    const [isLoaded, setIsLoaded ] = useState(false);

    const {
        selectedAgent
    } = useSelectedAgent(search.get('basAgent'));

    useEffect(() => {
        const init = async () => {
            const options = {
                companyId:    companyInfo.companyId,
                serialNumber: selectedAgent.serialNumber
            };

            await fetchLogs(options);
        };

        if (selectedAgent && !isLoaded) {
            setIsLoaded(true);

            init();
        }
    }, [selectedAgent]);

    const handleIotHubRoute = () => {
        history.push(`/iothub?company=${queryValues.company}`);
    };

    const handleSelectedAgentRoute = () => {
        history.push(`/iothub/basagents/manage?company=${queryValues.company}&basAgent=${queryValues.basAgent}`);
    };

    const handleLogClick = rowData => {
        setLogData({
            agentName:    selectedAgent.name,
            machineName:  rowData.machineName,
            name:         rowData.name,
            serialNumber: selectedAgent.serialNumber
        });

        history.push(`/iothub/basagents/manage/logs/advanced/log?company=${queryValues.company}&basAgent=${queryValues.basAgent}`);
    };

    const headerControl = () => {
        const id = get(selectedAgent, 'id', null);

        if (!selectedAgent || !id) return null;

        return (
            <Link to={`/iothub/basagents/manage/logs/classic?company=${queryValues.company}&basAgent=${selectedAgent.id}`}>Switch to the original interface.</Link>
        );
    };

    const renderLog = rowData => {
        return (
            <span
                onClick={() => handleLogClick(rowData)}
                role="none"
            >
                {rowData.name}
            </span>
        );
    };

    if (!selectedAgent) {
        return null;
    }

    return (
        <EsmsPage
            parents={[
                companyInfo.companyName,
                'BAS Agents',
                selectedAgent.name
            ]}
            handlers={[handleIotHubRoute, handleIotHubRoute, handleSelectedAgentRoute]}
            headerControl={headerControl}
            title="View Logs"
        >
            <div className={classes.AgentLogsPageTable}>
                <MaterialTable
                    options={{
                        paging:    false,
                        showTitle: false,
                        search:    false,
                        selection: false,
                        toolbar:   false,
                        sorting:   true
                    }}
                    columns={[
                        {
                            title:       'Name',
                            field:       'name',
                            defaultSort: 'asc',
                            render:      rowData => renderLog(rowData),
                        },
                        {
                            title: 'Description',
                            field: 'description',
                        }
                    ]}
                    data={logs}
                />
            </div>
        </EsmsPage>
    );
};

AgentLogsPage.defaultProps = {
    companyInfo: {},
    logs:        [],
    setLogData:  () => {}
};

AgentLogsPage.propTypes = {
    companyInfo: object,
    logs:        array,
    setLogData:  func
};

export const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo,
        logs:        state.iotHub.logs
    };
};

const mapDispatchToProps = {
    ...IotHubActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AgentLogsPage));
